const content = {
  email: 'townes.booking@gmail.com',
};

export default content;
